<template>
	<div class="main-order">
		<RestaurantCheckout v-if="status_checkout"
		@closeCheckout= "
		status_checkout = $event;"
		:data="order">
		</RestaurantCheckout>
		<div class="content-order" v-show="!status_checkout">
			<div class="header-order">
				<!--<div class="arrow-back">
					<i class="fas fa-long-arrow-alt-left" @click="back()"></i>
				</div>-->
				<div class="header-name">
					<h1>Detalle de orden</h1>
				</div>
			</div>
			<div class="deliver-method">
				<button class="method autoservicio" id="auto" v-bind:style="{backgroundColor : color_botones, color: color_botones}">
					Mesa
				</button>
				<button class="method domi" id="domicilio" v-bind:style="{backgroundColor : color_botones, color: color_botones }">
					Domicilio
				</button>
				<button class="method recogerlo" id="recoger" v-bind:style="{backgroundColor : color_botones, color: color_botones}">
					Recogerlo
				</button>
			</div>
			<div class="order-detail">
				<div class="single-product" v-for="item in order">
					<div class="product-name">
						<h3>{{ item.name_product.split('(')[0] }}</h3>
						<i class="fas fa-times" @click="DeleteProduct(item)"></i>
					</div>
					<div class="product-attribute">
						<h3 v-if="item.combination"><strong>{{ item.name_product.split(' ')[1].replace('(', ' ') }} </strong><span>{{ item.combination }}</span></h3>
						<h3 v-if="item.addition.length > 2"><strong>Adiciones: </strong>
							<span>{{ setTextAddition(item.addition) }}</span>
						</h3>
					</div>
					<div class="product-stats">
						<div class="product-price" v-if="type != 72">
							<h3>${{ Intl.NumberFormat("de-DE").format(item.valor * item.cantidad) }}</h3>
						</div>
						<div class="product-quantity">
							<i class="fas fa-minus" @click="removeQuantity(item)"></i>
							<label>{{ item.cantidad }}</label>
							<i class="fas fa-plus" @click="addQuantity(item)"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="order-discount">
				<div class="name-cupon">
					<h3>¿Quieres usar cupón?</h3>
					<h4 @click="status_discount = true">Usar cupón</h4>
				</div>
				<div class="detail-cupon" v-show="status_discount" v-bind:style="{borderColor : color_botones }">
					<div class="check-image" v-bind:style="{backgroundColor : color_botones }">
						<i class="fas fa-check"></i>
						<i class="fas fa-times"></i>
					</div>
					<div class="input-cupon">
						<input type="text" placeholder="Código...." v-model="coupon_value">
					</div>
					<div class="send-cupon">
						<i class="far fa-paper-plane" v-bind:style="{color : color_botones }" @click="ValidateCoupon()"></i>
					</div>
				</div>
				<div class="status-text">
					<h4 class="status-cop">{{ couponText }}</h4>
				</div>
				<div class="total-order" v-if="type != 72">
					<div class="subtotal">
						<h3>Subtotal:</h3>
						<h3>${{ Intl.NumberFormat("de-DE").format(subtotal) }}</h3>
					</div>
					<hr>
					<div class="domicilio">
						<h3>Domicilio:</h3>
						<h3>${{ Intl.NumberFormat("de-DE").format(domicilio) }}</h3>
					</div>
					<hr>
					<div class="domicilio" v-show="discount > 0">
						<h3>Descuento:</h3>
						<h3>${{ Intl.NumberFormat("de-DE").format(discount) }}</h3>
					</div>
					<hr>
					<div class="total">
						<h3>Total:</h3>
						<h3>${{ Intl.NumberFormat("de-DE").format(total_order) }}</h3>
					</div>
				</div>
			</div>
			<div class="confirm-button">
				<button class="send" v-bind:style="{backgroundColor : color_botones }" @click="Checkout()">Confirmar orden</button>
				<button class="back" v-bind:style="{color : color_botones, borderColor: color_botones }" @click="back()">Volver</button>
			</div>
		</div>
	</div>
</template>

<style type="text/css" scoped>


	*:focus{
		outline: none;
	}

	.content-order{
		width: 100%;
		height: auto;
		padding: 25px 0px 30px 0px;
	}

	.status-text{
		width: 100%;
		text-align: center;
		padding-top: 10px;
	}

	.status-text h4{
		font-size: 15px;
		font-weight: 500;
	}

	.success-coupon{
		background-color: #0DC142 !important;
	}

	.wrong-coupon{
		background-color: red !important;
	}

	.red{
		color: red !important;
	}

	.green{
		color: #0DC142 !important;
	}

	.header-order{
		width: 100%;
		padding: 15px 15px 5px 15px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.arrow-back{
		width: 20%;
		text-align: left;
	}

	.arrow-back i{
		font-size: 25px;
		color: #000;
		margin-bottom: .5rem;
		align-self: center;
	}

	.header-name{
		width: 100%;
		text-align: left;
	}

	.header-name h1{
		font-size: 22px;
		font-weight: 500;
		color: #000;
	}

	.deliver-method{
		width: 100%;
		padding: 0px 15px 15px 15px; /*arriba, derecha, abajo, izquierda*/
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.method{
		width: 32%;
		padding: 5px;
		border-radius: 5px;
		font-size: 15px;
		background: transparent;
		border: 1px solid;
		color: #fff;
	}

	.white{
		background: transparent !important; 
	}

	.text{
		color: #fff !important;
	}

	/*.method:focus{
		background-color: #000;
		color: #fff;
		outline: none;
	}*/

	.order-detail{
		width: 100%;
		border-radius: 20px;
		/*box-shadow: 0px -5px 8px 0px rgba(237,237,237,1);*/
		padding: 15px 15px 8px 15px;
		height: 46vh;
		overflow-y: scroll;
	}

	.single-product{
		margin-bottom: 10px;
		padding: 0px 15px 8px 15px;
		background-image: linear-gradient(to right, black 33%, rgba(255,255,255,0) 0%);
		background-position: bottom;
		background-size: 3px 1px;
		background-repeat: repeat-x;
	}

	.product-name{
		width: 100%;
		display:flex;
		justify-content: space-between; 
		margin-bottom: 7px;
	}

	.product-name h3{
		margin-bottom: 0 !important;
		font-size: 18px;
		font-weight: 600;
	}

	.product-name i{
		align-self: center;
	}

	.product-attribute{
		width: 100%;
		display: block;
		text-align: left;
	}

	.product-attribute span{
		color: #848484;
	}
	.product-attribute h3{
		margin-bottom: .2rem;
		font-size: 13px;
		color: #444444;
	}

	.product-stats{
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding-bottom: 6px;
	}
	.product-price{
		width: 72%;
		text-align: left;
		align-self: center;
	}

	.product-price h3{
		font-size: 20px;
		font-weight: 600;
		color: #4B4B4B;
		margin-bottom: 0 !important;
	}

	.product-quantity{
		align-self: center;
		width: 28%;
		padding: 6px 3px 6px 3px;
		display: flex;
		justify-content: space-around;
		border: 1px solid #000;
		align-items: center;
		border-bottom-left-radius: 15px;
		border-bottom-right-radius: 15px;
		border-top-left-radius: 15px;
	}

	.product-quantity label{
		margin-bottom: 0 !important;
	}

	.order-discount{
		width: 100%;
		padding:28px 25px 0px 25px;
		box-shadow: 0px -5px 8px 0px rgba(245,245,245,1);
		border-radius: 25px;
	}

	.name-cupon{
		width: 100%;
		padding: 0px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.name-cupon h3{
		font-size: 16px;
		font-weight: 500;
	}

	.name-cupon h4{
		font-size: 15px;
		font-weight: 500;
		text-decoration: underline;
	}

	.detail-cupon{
		width: 93%;
		display: flex;
		justify-content: flex-start;
		margin: 0 auto;
		align-items: center;
		border:1.5px solid #000;
		padding:3px;
		border-bottom-right-radius: 30px;
		border-bottom-left-radius: 30px;
		border-top-left-radius: 30px;
	}

	.check-image{
		width: 40px;
		height: 40px;
		border-radius:50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.check-image i{
		color: #fff;
		font-size: 16px;
	}

	.input-cupon{
		width: 75%;
		text-align: center;
	}

	.input-cupon input{
		height: 30px;
		font-size: 17px;
		border:none;
		padding-left: 10px;
	}

	.total-order{
		width: 100%;
		padding: 12px 15px 0px 15px;
		display: block;
		text-align: center;
	}

	.total-order h3{
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 0 !important;
	}

	.subtotal{
		width: 100%;
		padding: 5px 0px 5px 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.domicilio{
		width: 100%;
		padding: 5px 0px 5px 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.total{
		width: 100%;
		padding: 5px 0px 5px 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.total-order hr{
		border-top: 1px dotted #000;
		margin-bottom: 0 !important;
		margin-top: 0 !important;
	}

	.confirm-button{
		padding-left:25px;
		padding-right:25px;
		padding-top:15px;
		width: 100%;
	}

	.send{
		padding: 13px 0px;
		width: 100%;
		color: #fff;
		/*border-top-left-radius: 30px;
		border-bottom-left-radius: 30px;
		border-bottom-right-radius: 30px;*/
		border-radius: 8px;
		font-size: 19px;
		border-style: none;
		font-weight: 500;
		box-shadow: 0px 6px 16px 0px rgba(224,224,224,1);
	}

	.back{
		padding: 13px 0px;
		margin-top: 10px;
		width: 100%;
		color: #fff;
		border-radius: 8px;
		border: 1px solid;
		background: transparent;
		font-size: 19px;
		font-weight: 500;
	}

</style>

<script>
	import $ from 'jquery';
	import axios from 'axios';
	import RestaurantCheckout from './RestaurantCheckout';
	export default{
		props: ['order'],
		components:{
			RestaurantCheckout
		},
		data(){
			return {
				client_order: this.order,
				status_checkout: false,
				status_discount: false,
				total_order: 0,
				subtotal: 0,
				discount: 0,
				domicilio: localStorage.getItem('domicilio'),
				color_botones: localStorage.getItem('color_licencia'),
				domicilio_status : false,
				domi_aux : 0,
				mesa: JSON.parse(localStorage.getItem('btn-mesa')),
				recogerlo: JSON.parse(localStorage.getItem('btn-recogerlo')),
				btn_domicilio: JSON.parse(localStorage.getItem('btn-domicilio')),
				autoservicio: JSON.parse(localStorage.getItem('autoservicio')),
				companie_id: localStorage.getItem('companie_id'),
				type: localStorage.getItem('tipo'),
				addressIncluded: false,
				status_mesa: false,
				status_recogida: false,
				status_domi: true,
				couponSuccess: false,
		        couponError: false,
		        couponText: '',
				coupon:{
		          id_companie: "",
		          id_coupon: "",
		          coupon: "",
		          phone: "",
		          total: "",
		          cart: []
		        },
		        coupons: false,
		        coupon_value: "",
		        carrito: []
			}
		},
		watch:{
			
		},
		methods:{
			Checkout(){
				console.log(this.domicilio_status);
				localStorage.setItem('domicilio_status',this.domicilio_status);
				localStorage.setItem('status_recogida',this.status_recogida);
				this.status_checkout = true;
			},
			ValidateCoupon(){
				var self = this;
				this.coupon.id_companie = this.companie_id;
				this.coupon.coupon = this.coupon_value;
				this.coupon.total = this.total_order;
				if (this.domicilio > 0) this.coupon.total -= this.domicilio;
				this.couponText = '';
				this.coupon.cart = JSON.stringify(this.order);
				axios
		        .post('https://back.vinapp.co/api/get-coupon-client',this.coupon)
		        .then((res) => {
			        if(res.data.statusCode == 200){
			          $('.status-cop').addClass('green');
			          $('.check-image').removeClass('wrong-coupon');
			          $('.status-cop').show();		
			          $('.check-image').addClass('success-coupon');
			          $('.check-image .fa-times').hide();
			          $('.fa-check').show();
			          setTimeout(function(){ self.status_coupon = false; }, 2000);
			          setTimeout(function(){ $('.status-cop').hide(); }, 2000);		     
			          this.order = JSON.parse(res.data.cart);   
			          this.couponSuccess = true;
			          this.couponText = res.data.statusText;
			          this.coupon.id_coupon = res.data.id_coupon;
			          localStorage.setItem('res_id_coupon', res.data.id_coupon);
			          this.discount = parseFloat(res.data.valueCoupon);
			          this.total_order = this.total_order - parseFloat(res.data.valueCoupon);
			          let obj_coupon = {
			          	id_coupon: this.coupon.id_coupon,
			          	discount: this.discount
			          }
			          localStorage.setItem('data_coupon', JSON.stringify(obj_coupon));      		          
			        }else{
			          $('.status-cop').show();
			          $('.status-cop').removeClass('green');
			          $('.status-cop').addClass('red');
			          $('.check-image').addClass('wrong-coupon');
			          $('.check-image .fa-times').show();
			          $('.fa-check').hide(); 	         
			          this.couponError = true;
			          this.couponText = res.data.statusText;
			          setTimeout(function(){ $('.status-cop').hide(); }, 2000);
			        }
			    })
			    .catch((err) => {
			      console.log(err);
			    });
			},
			setTextAddition(adiciones){
				adiciones = JSON.parse(adiciones);
				console.log(adiciones);
				let index = 1
				let tamaño = adiciones.length;
				let text = "";
				adiciones.forEach((item) => {
					if(index < tamaño)text += item.quantity+'x '+item.option+', ';
					else text += item.quantity+'x '+item.option+'.';
					index += 1;
				});
				return text;
			},
			addQuantity(item){
				item.cantidad += 1;
				this.total_order += parseInt(item.valor);
			},
			back(){
				this.$emit('closeOrderDetail',false);
			},
			removeQuantity(item){
				if(item.cantidad > 1){
					item.cantidad -= 1;	
					this.total_order -= parseInt(item.valor);
				} 
			},
			setTotalOrder(){
				this.total_order = 0;
				this.subtotal = 0;
				this.status_domi ? this.domicilio_status = true : this.domicilio_status = false;
				this.order.forEach((item) => {
					this.subtotal += (parseInt(item.valor) * item.cantidad);
					this.total_order += (parseInt(item.valor) * item.cantidad);
					this.total_order -= item.descuento;
				});

				if(this.fnAddressIncluded()){
					this.domicilio_status = false;
					this.domicilio = 0;
				}
				if (this.domicilio_status) {
					this.total_order += parseInt(this.domi_aux);
					this.domicilio = parseInt(this.domi_aux);
				}
				if (this.status_mesa || this.status_recogida) {
					this.domicilio = 0;
					this.total_order += parseInt(this.domicilio);
				}
			},
			DeleteProduct(product){
				this.order.forEach((item) => {
					if (item.id_product == product.id_product) {
						if (product.descuento > 0) {
							this.discount -= product.descuento;
							if (this.discount == 0) {
								localStorage.removeItem('res_id_coupon');
								let position = this.order.indexOf(product);
								this.order.splice(position, 1);
							}
						}else{
							let position = this.order.indexOf(product);
							this.order.splice(position, 1);
						}						
					}
				});
				this.setTotalOrder();
				if (this.order.length == 0) {
					this.back();
				}
			},
			updateButton(number){
				//autoservicio
				if (number == 1) {
					$(".autoservicio").removeClass("white");
					$(".autoservicio").addClass("text");
					$(".domi").removeClass("text");
					$(".domi").addClass("white");
					$(".recogerlo").removeClass("text");
					$(".recogerlo").addClass("white");
				}
				if (number == 2) {
					$(".domi").removeClass("white");
					$(".domi").addClass("text");
					$(".autoservicio").removeClass("text");
					$(".autoservicio").addClass("white");
					$(".recogerlo").removeClass("text");
					$(".recogerlo").addClass("white");
				}
				if(number == 3){
					$(".recogerlo").removeClass("white");
					$(".recogerlo").addClass("text");
					$(".domi").removeClass("text");
					$(".domi").addClass("white");
					$(".autoservicio").removeClass("text");
					$(".autoservicio").addClass("white");
				}
			},
			setAvaliableButton(){
				if (this.autoservicio)document.getElementById('auto').innerText = 'Autoservicio';
				if (!this.mesa)document.getElementById('auto').disabled = true;
				if (this.recogerlo == false)document.getElementById('recoger').disabled = true;
				if (!this.btn_domicilio)document.getElementById('domicilio').disabled = true; 
			},
			setMesaParams(){
				if(this.$route.params.mesa){
			        document.getElementById("recoger").disabled = true;
        			document.getElementById("domicilio").disabled = true;
        			this.status_domi = false;
        			this.domicilio_status = false;
        			this.updateButton(1);
        			this.domicilio_status = false;
					this.domicilio = 0;
   				}	
			},
			fnAddressIncluded(){       
		      let status = false;     
		      const validar = this.order.filter(item => item.address_included == true);
		        if(validar.length > 0){   
		            status = true;
		        }        
		        return status;
		    },
		    VerifyMesa(){
		    	if(!this.$route.params.mesa){
		    		$(".recogerlo").removeClass("text");
					$(".recogerlo").addClass("white");
					$(".autoservicio").removeClass("text");
					$(".autoservicio").addClass("white");
					$(".domi").addClass("text");
				}
		    },
		    print(){
		    	setTimeout(function(){
		    		$(".recogerlo").removeClass("text");
					$(".recogerlo").addClass("white");
					$(".autoservicio").removeClass("text");
					$(".autoservicio").addClass("white");
					$(".domi").addClass("text");
		    	},0)
		    }
		},
		mounted(){
			if (localStorage.getItem('res_id_coupon')) {
				this.coupon.id_coupon = localStorage.getItem('res_id_coupon');
				this.ValidateCoupon();
			}
			$('.check-image .fa-times').hide();
			$('.status-cop').hide();
			this.setMesaParams();			
			this.setAvaliableButton();
			this.domicilio_status = true;
			this.domi_aux = this.domicilio;
			this.setTotalOrder();
			this.VerifyMesa();
			const auto = document.getElementById('auto');
			const domicilio = document.getElementById('domicilio');
			const recoger = document.getElementById('recoger');
			auto.addEventListener('click', () => {
				this.status_mesa = true;
				this.status_domi = false;
				this.status_recogida = false;
				this.domicilio_status = false;
				this.domicilio = 0;
				this.setTotalOrder();
				this.updateButton(1);
			});
			domicilio.addEventListener('click', () => {
				this.status_domi = true;
				this.status_recogida = false;
				this.status_mesa = false;
				console.log("algo");
				this.domicilio_status = true;
				this.domicilio = this.domi_aux;
				this.setTotalOrder();
				this.updateButton(2);
			});
			recoger.addEventListener('click', () => {
				this.status_recogida = true;
				this.status_mesa = false;
				this.status_domi = false;
				this.domicilio_status = false;
				this.domicilio = 0;
				this.setTotalOrder();
				this.updateButton(3);
			});
		}
	}
</script>